import styles from "./styles.module.scss";
import { useEffect, useRef, useState } from "react";
import { Button } from "../../../components/Button";
import { CardInfo } from "../components/CardInfo";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import { themeGrid } from "../../../themeGrid";
import { localeText } from "../../../localeTextFromGrid";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { IApiResponse } from "../../../@types/api-response.type";
import dayjs from "dayjs";
import { AddPlannedPerfil } from "../components/AddPlannedPerfil";
import { addAllocationsByProjectPlanned, getProjectPlannedsByProjectId } from "../../../services/api/ProjectPlanned/ProjectPlannedService";
import { IProjectPlannedResponse } from "../../../@types/project/project-planned.type";
import { HistoryPlannedModal } from "../components/HistoryPlannedModal";
import { toast } from "react-toastify";

function addColumnStartEndDate() {
  const startDateColumn = { 
    headerName: "Início",
    field: "startDate", 
    columnGroupShow: 'closed',
    cellRenderer: (params: CustomCellRendererProps) => {
      return dayjs(params.value).format("MMM/YY");
    }, 
  }

  const endDateColumn = { 
    headerName: "Término",
    field: "endDate",
    columnGroupShow: 'closed',
    cellRenderer: (params: CustomCellRendererProps) => {
      return dayjs(params.value).format("MMM/YY");
    },
  }
  
  return [startDateColumn, endDateColumn];
}

let columnsDefault: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  { field: "positionName", headerName: "Planejado", flex: 1, minWidth: 200, pinned: 'left' },
  { field: "resourceName", headerName: "Colaborador", flex: 1, minWidth: 200, pinned: 'left' },
  {
    headerName: "Período",
    children: addColumnStartEndDate()
  },
];

interface PlannedProjectProps {
  projectId: string,
}

export const PlannedProject: React.FC<PlannedProjectProps> = ({projectId}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [columns, setColumns] = useState(columnsDefault);
  const [obj, setObj] = useState<IProjectPlannedResponse>();
  const [idEdit, setIdEdit] = useState<string>("");
  
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const handleOpenHistoryModal = () => setOpenModalHistory(true);
  const handleCloseHistoryModal = () => setOpenModalHistory(false);
  
const addColumnMonths = (params) => {
  const startDate = dayjs(params.reduce((a, b) => {
    return new Date(a.startDate) < new Date(b.startDate) ? a : b;
  }).startDate);

  const endDate = dayjs(params.reduce((a, b) => {
    return new Date(a.endDate) > new Date(b.endDate) ? a : b;
  }).endDate);

  let column = addColumnStartEndDate();

  const monthDiff = endDate.diff(startDate, 'month') + 1;
  for (let index = 0; index < monthDiff; index++) {
    const month = startDate.add(index, 'month');
    const monthAndYear = month.format('MMM') + " / " + month.format('YY');

    const newColumn = { 
      field: monthAndYear,
      minWidth: 75,
      columnGroupShow: 'open',
      cellRenderer: (row: CustomCellRendererProps) => {
        const columnValue = row.data.projectPlannedMonthlies.find(x => x.month === parseInt(month.format('MM')) && x.year === parseInt(month.format('YYYY')));
        return columnValue && columnValue.workingHours ? `${columnValue.workingHours} h` : `${0} h`;
      },
    }
    column.push(newColumn);
  }
  columnsDefault[3].children = column;
  //gridRef.current!.api.setGridOption("columnDefs", columnsDefault)
}

  
  useEffect(() => {
    loadInfo();
  }, []);

  useEffect(() => {
    if(!openModal)
      loadInfo();
  }, [openModal]);
  
  const loadInfo = async () =>{
    const response = (await getProjectPlannedsByProjectId(projectId)) as IApiResponse<IProjectPlannedResponse>;
    setObj(response.result);
  }

  const updatePage = (id) => {
    setIdEdit(id);
    handleOpenModal();
  }

  const getDataSource = () => ({
    getRows: async (params: IGetRowsParams) => {
      console.log(params);

      try {
        if(obj){
          if(obj.projectPlanneds.length > 0)
            addColumnMonths(obj?.projectPlanneds)
          
          params.successCallback(
            obj.projectPlanneds,
            obj.projectPlanneds.length
          );
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        params.failCallback(); // Notifica falha no carregamento
      }
    },
  });

  async function AddAllocations(projectId: string) {
    try {
      setLoading(true);
      await addAllocationsByProjectPlanned(projectId);
      toast.success("Alocação gerada com sucesso!");
    } catch (error) {
      console.log(error);
      toast.error(
        "Não foi possível gerar a alocação! Tente novamente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.planned}>
      <div className={styles.container}>
        <h3 className={styles.title}>Planejado</h3>
        <div className={styles.divButtons}>
        {
          obj && obj?.projectPlanneds.length > 0 &&
          <Button
            onClick={() => AddAllocations(projectId)}
            content="Gerar Alocação"
            className={styles.btnAdd}
          />
        }
        <Button
            content="Ver Historico"
            onClick={() => {
              handleOpenHistoryModal();
            }}
            className={styles.btnAdd}
          />
          <Button
            content="Adicionar Colaborador"
            onClick={() => {
              setIdEdit("");
              handleOpenModal();
            }}
            className={styles.btnAdd}
          />
        </div>
      </div>

      <div className={styles.infoContainer}>
        <CardInfo text="Horas Contratadas" value={obj ? obj.budgetHoursTotal : 0} type="hour" icon="AccessTimeIcon" />
        <CardInfo text="Horas Planejadas" value={obj ? obj.plannedHoursTotal : 0} type="hour" icon="AvTimerIcon" />
        <CardInfo text="Custo Contratado" value={obj ? obj.budgetPriceTotal : 0}  type="money" icon="AttachMoneyIcon" />
        <CardInfo text="Custo Planejado" value={obj ? obj.plannedPriceTotal : 0}  type="money" icon="MoneyOffIcon" />

      </div>
      <div className={styles.dataGridContainer}>
        <AgGridReact
            ref={gridRef}
            theme={themeGrid}
            localeText={localeText}
            loading={loading}
            columnDefs={columns}
            overlayNoRowsTemplate="<span style='color: gray;'>Sem registros encontrados</span>"
            defaultColDef={{
              sortable: true,
              editable: false,
              filter: true,
              floatingFilter: true,
            }}
            suppressCellFocus={true}
            rowStyle={{ cursor: "pointer" }}
            onRowClicked={(row) => updatePage(row.data.id)}
            cacheBlockSize={50}
            rowModelType="infinite"
            datasource={getDataSource()}
            animateRows={true}
          />
      </div>
      { openModal &&
        <AddPlannedPerfil projectId={projectId}  id={idEdit} openModal={openModal} handleCloseModal={handleCloseModal} />
      }

      { openModalHistory &&
        <HistoryPlannedModal projectId={projectId} id={idEdit} openModal={openModalHistory} handleCloseModal={handleCloseHistoryModal} />
      }

    </div>
  );
};